export default (function (milliseconds) {
    if (milliseconds === void 0) { milliseconds = 800; }
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve(true);
        }, milliseconds);
    });
});
